import { useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { useState } from "react";
import { showModal } from "../../features/modal/modalSlice";
import { setSelectedBlockedUserAdmin } from "../../features/admin3/admin3Slice";
import { BsTelephonePlus } from "react-icons/bs";


const Container = styled.div`
  width: 100%;
  margin-block: 5px;
  .container {
    width: 100%;
    cursor: pointer;
    .content {
      width: 100% !important;
      padding: 30px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: ${({ theme }) => theme.secondaryBgColor};
      color: ${({ theme }) => theme.mainTextColor} !important;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      .row {
        width: 100%;
        display: grid;
        grid-template-columns:  0.4fr 0.4fr 1fr 1fr;
        gap: 15px;
        align-items: flex-start;
        background-color: transparent;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          flex-direction: column; 
          .isReviewed{
            font-size: var(--font-size-xs);
            font-weight: var(--font-weight-lg);
            color: var(--color-main);
            margin-top: 10px;
          }
          .noname{
            font-size: var(--font-size-xs);
            font-weight: var(--font-weight-lg);
            color: var(--color-main);
          }
          .list{
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start !important;
            gap: 10px;
          }
          .show-btn{
            margin-top: 10px;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            text-decoration: underline;
            color: var(--color-main);
          }
          .result-p{
            color: var(--color-main);
            text-decoration: underline;
          }
          .red{
            background-color: #E85446;
            padding: 10px;
            border-radius: 10px;
            color: #fff;
          }
          .yellow{
            background-color: #f3d825;
            padding: 10px;
            color: #fff;
            border-radius: 10px;
          }
          .user{
            display: flex;
            flex-direction: column;
            gap: 10px;
            width: 100%;
            text-align: left;
            border-bottom: 2px solid ${({ theme }) => theme.mainBorderColor};
            padding-bottom: 10px;
            .bold{
              font-weight: var(--font-weight-lg);
            }
            .active{
              font-size: var(--font-size-xs);
              font-weight: var(--font-weight-lg);
              color: var(--color-main);
              /* text-decoration: underline; */
            }
          }
          .user:last-child{
            border-bottom: none;
            padding-bottom: 0px;

          }
          .result{
            width: 100%;
            height: 100%;
            position: relative;
            align-items: flex-start;
            justify-content: flex-start;
            display: flex;
            flex-direction: column;
            gap: 10px;
            text-align: left;
            .edit-container{
              position: absolute;
              top: -20px;
              right: 0;
              display: flex;
              align-items: center;
              gap: 15px;
              .border{
                height: 20px;
                width: 2px;
                background-color: ${({ theme }) => theme.mainBorderColor};
              }
              svg{
                font-size: 18px;
                cursor: pointer;
              }
              .edit{
                color: var(--color-main);
                cursor: pointer;
                text-decoration: underline;
              }
            }
            
          }
          
        }
      }
    }
  }
  
  
`;

const statusData = [
  {
    id:1,
    state: 0,
    text: "İncelenmedi"
  },
  {
    id:2,
    state: 1,
    text: "Kamyoon Tarafından Engellendi"
  },
  {
    id:3,
    state: 2,
    text: "Firmaların Engelinde"
  },
]

const AdminEngellenenAraclarContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  const [status, setStatus] = useState(null);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    setStatus(statusData.find(status => status.state === data.state));
  }, [data])

  useEffect(() => {
    if (data?.durum) {
      const matchedStatus = statusData.find(status => status.text === data.durum);
      setStatus(matchedStatus);
    }
  }, [data?.durum]);
  // copyBlockedUser

  return (
    <Container>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">
              {status?.state === 0 && <p>İncelenmedi</p> }
              {status?.state === 1 && <p className="yellow" >Firmaların Engelinde</p> }
              {status?.state === 2 && <p className="red">Kamyoon Tarafından Engellendi</p> }
              {!data.isReviewed && <p className="isReviewed">Yeni kayıt mevcut!</p>}

            </div>
            <div className="col">{data.phoneNumber} {data.blackListUserId === null && <span className="noname">(Kamyoon'a kayıtlı değil)</span>} </div>
            <div className="col">
              <div className="list">
              {(showAll ? 
                [...data?.blockedUserDetails]?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : 
                [...data?.blockedUserDetails]?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).slice(0, 1)
              )?.map((item, index) => (
                <div className="user" key={index}>
                  <p><span className="bold">{item.savedByCompanyName}</span> ({item.savedByUserName}) ({moment(item.createdAt).format("LLL")}) {!item.isActive && <span className="active">Engel kaldırılmış.</span> } </p>
                  <p>{item.fullNameTitle && `Ad Soyad: ${item.fullNameTitle}`} {item.nationalId && `(TC: ${item.nationalId})`} {item.blockedVehicles?.length > 0 && `(Plakalar: ${item.blockedVehicles.map(vehicle => vehicle.plate).join(", ")})`} {item.count > 1 && <span className="noname">{item.count} Kayıt Var</span>}</p>
                  <p><span className="bold">Gerekçe:</span> {item.description}</p>
                  {/* {!item.isActive && <div className="active"> Engel kaldırılmış.</div>} */}
                </div>
              ))}
              </div>
              {data.blockedUserDetails?.length > 1 &&
                <div onClick={() => setShowAll(!showAll)} className="show-btn">{showAll ? "Gizle" : `Tümünü Gör (${data.blockedUserDetails?.length})`}</div>
              }
            </div>
            <div className="col">
              {data?.description ? 
                <div className="result">
                  <div className="edit-container">
                    <span className="edit" onClick={() => {dispatch(setSelectedBlockedUserAdmin(data)); dispatch(showModal("adminKaralisteTelefonEkle"))}}><BsTelephonePlus /></span>
                    <div className="border" />
                    <span className="edit" onClick={() => {dispatch(setSelectedBlockedUserAdmin(data)); dispatch(showModal("adminKaraListeSonuc"))}}>Düzenle</span>
                  </div>
                  <p>{data.savedByUserAdmin} ({moment(data.updatedAt).format("LLL")})</p>
                  <p>{data?.description}</p>
                </div>
                :
                <p className="result-p" onClick={() => {dispatch(setSelectedBlockedUserAdmin(data)); dispatch(showModal("adminKaraListeSonuc"))}}>İnceleme Sonucu Gir</p>
              }
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AdminEngellenenAraclarContainer;
